const LAYOUT = {
  maxWidth: 'lg',
}

export default LAYOUT
